function initSchools() {
  const schoolsSlider = document.querySelector('.schools__slider');

  if (schoolsSlider) {
    const swiper = new Swiper(schoolsSlider, {
      slidesPerView: 'auto',
      spaceBetween: 0,

      navigation: {
        nextEl: '.schools__slider-controls .swiper-controls__btn--next',
        prevEl: '.schools__slider-controls .swiper-controls__btn--prev',
      },

      breakpoints: {
        0: {
          slidesPerView: 2.8,
        },
        1024: {
          slidesPerView: 6,
        },
      },
    })
  }
}

export { initSchools };
